import { Language } from '../models';
import { HasId } from '../interfaces';
import { CharacteristicScore } from './CharacteristicScore';
import { CharacteristicCharacteristicScore } from './CharacteristicCharacteristicScore';
import { CharacteristicGroupCharacteristic, CharacteristicGroupSubGroupCharacteristic } from './CharacteristicGroup';

export class CharacteristicText implements HasId {
    public id: number;
    public textType: string;
    public value: string;
    public languageId: number;
    public language: Language;
    public showModal: boolean;
}

export class Characteristic implements HasId {
    public id: number;
    public name: string;
    public displayName: string;
    public description: string;
    public characteristicGroupID?: number;
    public characteristicTexts: CharacteristicText[];    
    public characteristicFocusType: string;
    public characteristicFilterType: string;
    public characteristicScores: CharacteristicScore[];
    public characteristicCharacteristicScores: CharacteristicCharacteristicScore[];
    public characteristicGroupCharacteristics: CharacteristicGroupCharacteristic[];
    public characteristicGroupSubGroupCharacteristics: CharacteristicGroupSubGroupCharacteristic[];
    public midStart: number;
    public midEnd: number;
    public sort: number;
    public prevCharacteristicID: number;
    public modifiedDate: Date;
    public showModal: boolean;
    public surveyVersionID: number;
}

export class UserCharacteristicToggle {
    characteristicId: number;
    userId: number;
}


// WEBPACK FOOTER //
// ./src/models/Characteristic.tsx